// Shared UI copy for the FrameX pipeline.
//
// Same contract as derive.js: no stores, no Svelte, no `#src` imports, so
// these stay unit-testable under `node --test`.

/** The plural suffix for a count — `${n} sheet${plural(n)}`. */
export function plural(n) {
  return n === 1 ? "" : "s";
}

/**
 * "N of M frames built". The panel's Step 3 subline and Step 3's own review
 * strip both open with this sentence, so it is written once. ("Build", not
 * "Rebuild" — see VOCABULARY: rebuild implies something was broken.)
 */
export function builtLabel(analyzed, total) {
  return `${analyzed} of ${total} frame${plural(total)} built`;
}

/**
 * Joins items for prose: "A", "A and B", "A, B, and C". Two items take no
 * comma, three or more take the serial comma — a plain `join(", ")` reads as a
 * list of separate things rather than a sentence.
 */
export function joinList(parts) {
  if (parts.length < 2) return parts.join("");
  if (parts.length === 2) return `${parts[0]} and ${parts[1]}`;
  return `${parts.slice(0, -1).join(", ")}, and ${parts[parts.length - 1]}`;
}
